import instance from '@/api/business' 
import { Employee } from '@/types/Employee' 

const BASE_URL = '/resale/im/Employee'

export const fetchEmployee = async (SK_REVENDA: number) => {
    const response = await instance.post<Employee[]>(BASE_URL, {
        SK_REVENDA: SK_REVENDA
    })

    return response.data
} 